function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMap = function SvgIconMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "m2 3.91 6.732 4.277.3.19.279-.22 5.729-4.55L22 7.783V20.09l-6.732-4.277-.3-.19-.279.22-5.729 4.55L2 16.217V3.91zM9 8v12.5M15 4v11.5"
  }));
};
export default SvgIconMap;